var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3434_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.12451 5.59813H0.436683V7.93992C2.38818 9.50112 2.38818 10.8523 2.38818 12.992V15.3556C2.38818 15.7697 2.22369 16.1667 1.93091 16.4595C1.63813 16.7523 1.24104 16.9168 0.826982 16.9168H-1.12451M17.6098 5.59813H16.0486V7.93992C14.0971 9.50112 14.0971 10.8523 14.0971 12.992V15.3556C14.0971 15.7697 14.2616 16.1667 14.5544 16.4595C14.8472 16.7523 15.2443 16.9168 15.6583 16.9168H17.6098M4.72997 12.992V15.3556C4.72997 15.7697 4.89445 16.1667 5.18723 16.4595C5.48001 16.7523 5.87711 16.9168 6.29116 16.9168H10.1942C10.6082 16.9168 11.0053 16.7523 11.2981 16.4595C11.5909 16.1667 11.7553 15.7697 11.7553 15.3556V12.992C11.7553 10.8531 11.7553 9.50112 9.80385 7.93992V5.59813H6.68146V7.93992C4.72997 9.50112 4.72997 10.8523 4.72997 12.992ZM9.80385 2.04329C9.80385 2.91756 9.10522 3.64664 8.24266 3.64664C7.3801 3.64664 6.68146 2.91756 6.68146 2.04329C6.6825 1.95794 6.69499 1.87052 6.71893 1.78101C6.86725 1.21039 7.26301 0.745937 7.62911 0.290068L7.72278 0.17454C8.23719 -0.553758 8.24266 -1.16028 8.24266 -1.42725C8.24266 -1.16028 8.24812 -0.552977 8.76332 0.17454L8.85699 0.290068C9.22231 0.745937 9.61807 1.21039 9.76638 1.78101C9.79084 1.87052 9.80333 1.95794 9.80385 2.04329Z",
    stroke: "#4B5563",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3434_1427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7343,
    height: 18.7343,
    fill: "white",
    transform: "translate(-1.12451 -1.42725)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefills);
export default __webpack_public_path__ + "static/media/refills.e6162ef19493f11d82036ad54dfa04dc.svg";
export { ForwardRef as ReactComponent };